import { hotTags } from '@/mocks/movies';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20atmosphere%20with%20warm%20golden%20and%20amber%20lighting%2C%20film%20projector%20beam%20cutting%20through%20darkness%2C%20abstract%20geometric%20patterns%2C%20elegant%20dramatic%20composition%2C%20luxurious%20dark%20velvet%20texture%2C%20warm%20spotlights%20creating%20atmosphere%2C%20no%20text%2C%20minimalist%20yet%20dramatic&width=1800&height=1000&seq=hero-bg-main&orientation=landscape"
        alt="丫丫影院 - 免费高清影视在线观看"
        title="丫丫影院官网首页 - 免费高清影视在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 text-center mb-3 md:mb-5">
          丫丫影院
        </h1>
        <p className="text-sm md:text-lg text-background-50/80 text-center max-w-2xl mb-6 md:mb-8 leading-relaxed">
          免费高清影视在线观看，不缓冲最新电影电视剧全集，官方平台安全直达
        </p>

        <div className="w-full max-w-xl relative mb-6 md:mb-8">
          <i className="ri-search-line absolute left-5 top-1/2 -translate-y-1/2 text-foreground-400 text-lg"></i>
          <input
            type="text"
            placeholder="搜索你喜欢的电影、电视剧..."
            className="w-full pl-13 pr-5 py-4 rounded-xl bg-background-50/95 backdrop-blur-sm border border-background-50/20 text-base text-foreground-900 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 transition-all"
          />
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2 max-w-xl">
          {hotTags.map((tag) => (
            <Link
              key={tag}
              to={`/category/action`}
              className="px-4 py-2 rounded-full bg-background-50/10 hover:bg-primary-500/80 text-xs md:text-sm text-background-50/90 hover:text-background-50 transition-all backdrop-blur-sm border border-background-50/10 hover:border-primary-500 whitespace-nowrap cursor-pointer"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}